import React from 'react'
import './EmptyPlaceholderStyle.css'
import Button from '../Button/Button.component'

type EmptyPlaceholderProps = {
  title: string
  content: string
  icon: string
  buttonText?: string
  onAdd?: () => void
  className?: string
}

const EmptyPlaceholder: React.FC<EmptyPlaceholderProps> = ({
  title,
  content,
  icon,
  onAdd,
  buttonText,
  className,
}) => {
  return (
    <div className={`empty-placeholder-container ${className ?? ''}`}>
      <span className={`epc-icon ${icon}`} />
      <div className="epc-title">{title}</div>
      <div className="epc-subtitle">{content}</div>
      {onAdd && (
        <Button size="md" className="button-primary epc-button" onClick={onAdd}>
          {buttonText ?? 'Add'}
        </Button>
      )}
    </div>
  )
}

export default EmptyPlaceholder
